import React from 'react'
import { Link } from 'gatsby'

export default (link) => {
  return (
    <p>
      Durch die Nutzung dieser Website erklärst du dich mit unseren <Link to="/cookie-policy">Cookie Richtlinien</Link>{' '}
      einverstanden
    </p>
  )
}
